<div class="mainclass landing-page">
    <div class="root responsivegrid">
        <div
            class="responsivegrid aem-GridColumn--default--none aem-GridColumn aem-GridColumn--default--12 aem-GridColumn--offset--default--0">
            <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                <div class="banner aem-GridColumn aem-GridColumn--default--12">
                    <div class="container-fluid">

                        <input type="hidden" id="trigger-element" name="trigger-element"
                            value="Repayments calculator" />
                        <section>
                            <div class="row image-banner-container themebg">
                                <div
                                    class="nbd-img-banner col-12 col-sm-6 col-md-6 col-lg-6 img-align pl-0 pr-0 shadow-box">
                                    <figure class="nbd-banner-img">
                                        <img
                                          src="assets/static/media/PersonalLoans.jpg"
                                          alt="happy-family-travelling-in-car"
                                          class="banner-img"
                                          loading="eager"
                                          fetchpriority="high"
                                          width="1200"
                                          height="800"
                                        />
                                      </figure>
                                      

                                </div>
                                <div class="col-12 col-sm-6 col-md-6 col-lg-6 nbd-banner-content">
                                    <div class="col-12 p-0">
                                        <div class="nbd-banner-details offset-md-1">
                                            <h1>
                                                Let SmartFunder fund your studies
                                                <span>with a Nedbank Education Loan</span>
                                            </h1>
                                            <p> Studying is hard enough. Funding it shouldn't be. Get a Nedbank Personal
                                                Loan of up to R400 000 with a personalised interest rate to make
                                                reaching your dreams a little easier.</p>
                                            <div class="nbd-btn-row-in-banner">
                                                <div class="col-12 nbd-banner-buttons ">
                                                    <!-- Left side Button -->



                                                    <!-- left side buttons -->

                                                    <!-- Right side Button -->



                                                    <a href="/apply" target="_self"
                                                        aria-label="Apply now loan you can afford  Apply for a personal "
                                                        class="btn nbd-btn nbd-btn-commitment nbd-banner-btn"
                                                        id="nbdbannerbutton">Apply now</a>




                                                    <!-- right side buttons -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <div class="spacing aem-GridColumn aem-GridColumn--default--12">


                    <div style="height:64px;" class="clearfix "></div>
                </div>
                <div class="spacing aem-GridColumn aem-GridColumn--default--12">


                    <div style="height:80px;" class="clearfix bg-faded-green"></div>
                </div>
                <div class="headingwithdesc aem-GridColumn aem-GridColumn--default--12">
                    <div class="bg-faded-green">
                        <div class="nbd-head-desc-wrapper">
                            <h2 class="nbd-league-pagetitle">Why choose <span>a Nedbank Education Loan?</span></h2>
                            <div class="nbd-head-desc"></div>
                        </div>
                    </div>
                </div>
                <div class="informationcard aem-GridColumn aem-GridColumn--default--12">
                    <div class="eligibility-info bg-faded-green">
                        <div class="qualify-list">
                            <div class="row nb-row">
                                <div class="col-12 col-sm-6 col-md-6">
                                    <div class="card nb-card">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="icon-wrapper">
                                                    <img src="assets/images/icons/discount.svg" class="card-icon"
                                                        alt="" />
                                                </div>
                                            </div>

                                            <p class="card-text">You get a personalised interest rate tailored for you.
                                            </p>


                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-md-6">
                                    <div class="card nb-card">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="icon-wrapper">
                                                    <img src="assets/images/icons/accept-offer.svg" class="card-icon"
                                                        alt="" />
                                                </div>
                                            </div>

                                            <p class="card-text">Clear pricing and flexible loan repayment terms.
                                            </p>


                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="spacing aem-GridColumn aem-GridColumn--default--12">


                    <div style="height:80px;" class="clearfix bg-faded-green"></div>
                </div>
                <div class="headingwithdesc aem-GridColumn aem-GridColumn--default--12">
                    <div class="bg-faded-green">
                        <div class="nbd-head-desc-wrapper">
                            <h2 class="nbd-league-pagetitle">How it<span> works?</span></h2>
                            <div class="nbd-head-desc"></div>
                        </div>
                    </div>
                </div>
                <div class="spacing aem-GridColumn aem-GridColumn--default--12 bg-faded-green"></div>


                <div style="height:80px;" class="clearfix bg-faded-green"></div>
            </div>
            <div class="informationcard aem-GridColumn aem-GridColumn--default--12 bg-faded-green">
                <div class="illustrationcardwrapper">
                    <div class="ng-container">
                        <div class="row nb-row">
                            <div class="col-12 col-sm-6 col-md-4">
                                <div class="card nb-card boxShadow">
                                    <div class="card-header centrealignedillustration bordered-header border-bottom-0">
                                        <div class="icon-wrapper ">
                                            <img src="assets/images/icons/Dropdown-Menu-Select-Option-Form.svg"
                                                alt="Apply for your loan online" class="card-icon" />

                                        </div>

                                    </div>
                                    <div class="card-body border-top-0">
                                        <h4>Request a call back now</h4>
                                        <p></p>

                                        <div class="description">
                                            <p>Get assisted by a Nedbank Consultant to apply and/or check if you
                                                qualify.</p>
                                        </div>


                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4">
                                <div class="card nb-card boxShadow">
                                    <div class="card-header centrealignedillustration bordered-header border-bottom-0">
                                        <div class="icon-wrapper ">
                                            <img src="assets/images/icons/Compose-Write-Pencil.svg"
                                                alt="Apply for your loan online" class="card-icon" />

                                        </div>

                                    </div>
                                    <div class="card-body border-top-0">
                                        <h4>Accept your loan offer</h4>
                                        <p></p>

                                        <div class="description">
                                            <p>You will get the opportunity to review your personalised offer and, if
                                                you're happy with it, accept the loan.</p>
                                        </div>


                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4">
                                <div class="card nb-card boxShadow">
                                    <div class="card-header centrealignedillustration bordered-header border-bottom-0">
                                        <div class="icon-wrapper ">
                                            <img src="assets/images/icons/income.svg" alt="Apply for your loan online"
                                                class="card-icon" />

                                        </div>

                                    </div>
                                    <div class="card-body border-top-0">
                                        <h4>We pay you directly
                                        </h4>
                                        <p></p>

                                        <div class="description">
                                            <p>We pay funds directly to your bank account held with any bank and you
                                                pay the education institution, so you can study with peace of mind
                                                knowing that your fees are taken care of.</p>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="responsivegrid aem-GridColumn--default--none aem-GridColumn aem-GridColumn--default--12 aem-GridColumn--offset--default--0">


                <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 bg-faded-green ">

                    <div class="eligibilityneeds aem-GridColumn aem-GridColumn--default--12">



                        <div class="eligibility">
                            <div class="qualify-list">

                                <div>
                                    <h2 class="eligibility__title">
                                        Things to note before you <span class="eligibility__subtitle">apply for a
                                            Nedbank Education Loan</span>
                                    </h2>
                                </div>

                                <div class="row nb-row">
                                    <div class="col-12 col-sm-6 col-md-3">
                                        <div class="card nb-card">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="icon-wrapper">
                                                        <img src="assets/images/icons/sa-id.svg" class="card-icon"
                                                            alt="" />
                                                    </div>
                                                </div>
                                                <p class="card-text">You must be a South African resident from the ages
                                                    of 18 to 65.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-3">
                                        <div class="card nb-card">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="icon-wrapper">
                                                        <img src="assets/images/icons/income.svg" class="card-icon"
                                                            alt="" />
                                                    </div>
                                                </div>
                                                <p class="card-text">The applicant (you or your parent, guardian or
                                                    guarantor) must have a minimum income or salary of R5 000 that is
                                                    paid electronically into their account.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6 col-md-3">
                                        <div class="card nb-card default-card bg-green">
                                            <div class="card-body">
                                                <h5 class="card-text ta-center">Apply now</h5>

                                                <a href="/apply" class="stretched-link card-link"
                                                    data-pagequicklinktype="link" data-pagequicklinkname="Apply now"
                                                    data-pagequicklinklocation="Things to note before you apply for a personal loan | main content"><span
                                                        class="ar-icon-arrow"></span></a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="eligibilitybg"></div>


                            </div>
                            <div class="doclist bg-white mt-5">
                                <div>
                                    <h2 class="eligibility_doc__title">
                                        Documents <span class="eligibility__subtitle">you&#39;ll need</span>
                                    </h2>
                                </div>
                                <div class="row nb-row">

                                    <div class="col-12 col-sm-6 col-md-3">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-2 right-wrapper">
                                                    <img src="assets/images/icons/right-tick.svg" class="right-icon"
                                                        alt="" />
                                                </div>
                                                <div class="col-10 doc-text">
                                                    Your valid South African identity card or document
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <div class="col-12 col-sm-6 col-md-3">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-2 right-wrapper">
                                                    <img src="assets/images/icons/right-tick.svg" class="right-icon"
                                                        alt="" />
                                                </div>
                                                <div class="col-10 doc-text">
                                                    Stamped bank statements for the last 3 months
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6 col-md-3">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-2 right-wrapper">
                                                    <img src="assets/images/icons/right-tick.svg" class="right-icon"
                                                        alt="" />
                                                </div>
                                                <div class="col-10 doc-text">
                                                    Three months' payslips
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="tabsnedbank tabs aem-GridColumn aem-GridColumn--default--12">

                <div class="cmp-tabs" data-cmp-is="tabs">
                    <div class="nbd-page-bg ">
                        <div class="ng-container">


                            <div class="row">
                                <div class="col-md-12">
                                    <h3 class="nbd-calcul-head-title"
                                        aria-label="Use our loan calculators to see what works for you  ">
                                        Use our loan calculator to see what works for you <span>
                                        </span>
                                    </h3>
                                </div>
                            </div>


                            <ol role="tablist" class="cmp-tabs__tablist nbd-tabs calcTabs__tablist"
                                aria-multiselectable="false">

                                <li role="tab" class="cmp-tabs__tab" tabindex="-1" data-tabtitle="nbd_item_1"
                                    data-cmp-hook-tabs="tab" data-pageQuickLinkType="tab"
                                    data-pageQuickLinkName="Repayments calculator" data-index="0">
                                    Repayments
                                    calculator
                                </li>

                                <!-- 

                                    <li role="tab" class="cmp-tabs__tab" tabindex="-1" data-tabtitle="nbd_item_2"
                                        data-cmp-hook-tabs="tab" data-pageQuickLinkType="tab"
                                        data-pageQuickLinkName="Loan consolidation calculator" data-index="1">
                                        Loan
                                        consolidation calculator
                                    </li> -->

                            </ol>
                            <div role="tabpanel" tabindex="0" class="contentTabs calcTabs__tabpanel cmp-tabs__tabpanel"
                                data-tabcontainer="nbd_item_1" data-cmp-hook-tabs="tabpanel">
                                <div class="container responsivegrid">


                                    <div class="cmp-container">



                                        <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">

                                            <div class="repaymentcalculator aem-GridColumn aem-GridColumn--default--12">

                                                <input type="hidden" id="vatratecal" name="vatratecal" value="15" />
                                                <input type="hidden" id="initiationfeemaxnca" name="initiationfeemaxnca"
                                                    value="1050" />
                                                <input type="hidden" id="initiationfeebasenca"
                                                    name="initiationfeebasenca" value="1000" />
                                                <input type="hidden" id="initiationfeefixedpartnca"
                                                    name="initiationfeefixedpartnca" value="165" />
                                                <input type="hidden" id="initiationfeepercent1nca"
                                                    name="initiationfeepercent1nca" value="10" />
                                                <input type="hidden" id="initiationfeepercent2nca"
                                                    name="initiationfeepercent2nca" value="15" />
                                                <input type="hidden" id="monthlyServiceFeeExclVATcal"
                                                    name="monthlyServiceFeeExclVATcal" value="60" />
                                                <input type="hidden" id="insuranceMultipliercal"
                                                    name="insuranceMultipliercal" value="0.0035" />
                                                <input type="hidden" id="insuranceFlatFeecal" name="insuranceFlatFeecal"
                                                    value="0" />
                                                <input type="hidden" id="maxloanamount" name="maxloanamount"
                                                    value="400000" />
                                                <input type="hidden" id="minloanamount" name="minloanamount"
                                                    value="2000" />
                                                <input type="hidden" id="defaultterm" name="defaultterm" value="24" />
                                                <input type="hidden" id="interestval" name="interestval" value="18" />


                                                <div class="calculator-container repayment-container">
                                                    <div class="row">
                                                        <div class="col-md-12 col-sm-12">
                                                            <h5 class="calc-header">We&#39;ll show
                                                                you how much
                                                                your repayments will be for
                                                                the amount
                                                                you&#39;d like to borrow.</h5>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-12 col-sm-12">

                                                            <div class="row">
                                                                <div class="col-md-6 col-sm-12 left-panel">
                                                                    <div>
                                                                        <h6 class="nbd-title h7">How
                                                                            much do you
                                                                            need to borrow?</h6>
                                                                        <div>
                                                                            <span class="nbd-currency-input">R</span>
                                                                            <input id="loanamount" name="loanamount"
                                                                                type="text" pattern="[0-9]*"
                                                                                data-inputtype="number"
                                                                                class="form-control nbd-form-control"
                                                                                aria-describedby="loanDesc" min="2000"
                                                                                value="2000" max="400000"
                                                                                autocomplete="off" />
                                                                            <div id="loanDesc"
                                                                                class="loan-desc text-muted">
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div>
                                                                        <h6 class="nbd-title h7" for="myRange">
                                                                            What’s your preferred
                                                                            repayment
                                                                            term?</h6>
                                                                        <div class="slidecontainer">
                                                                            <output class="bubble"
                                                                                for="myRange"></output>
                                                                            <input type="range" min="0" max="" value=""
                                                                                class="slider" id="myRange" />
                                                                            <p class="range-info" id="min-term">
                                                                            </p>
                                                                            <p id="maxtermvalue"
                                                                                class="range-info float-right">
                                                                            </p>
                                                                        </div>


                                                                        <ul id="term-list" class="d-none">
                                                                            <li>6</li>

                                                                            <li>12</li>

                                                                            <li>24</li>

                                                                            <li>36</li>

                                                                            <li>48</li>

                                                                            <li>60</li>

                                                                            <li>72</li>
                                                                        </ul>



                                                                    </div>

                                                                    <!-- <div class="person-loan-wrapper">
                                                                        <h6 class="nbd-title h7">
                                                                            Include insurance
                                                                            in your repayment
                                                                            <a href="javaScript:void(0)"
                                                                                data-toggle="tooltip"
                                                                                data-placement="top" aria-labelledby=""
                                                                                class="nbd-tooltip"
                                                                                title="This covers your repayments if you lose your income, become disabled or when you die. You need to have insurance for the full loan term.">
                                                                                <img src="assets/images/icons/tooltipon.svg"
                                                                                    class="tooltip-img"
                                                                                    alt="tooltip text" />
                                                                            </a>
                                                                        </h6>

                                                                        <div class="radio-wrapper">
                                                                            <input type="radio" name="personalInsurance"
                                                                                id="personal-insurance-yes" checked />
                                                                            <label for="personal-insurance-yes"
                                                                                class="nbd-personal-loan">Add
                                                                                <span id="loaninsurancevalue"></span>
                                                                                to the loan amount
                                                                                for

                                                                                <a href="https://personal.nedbank.co.za/learn/blog/why-you-must-have-insurance-on-your-personal-loan.html"
                                                                                    rel="noopener noreferrer"
                                                                                    target="_blank"
                                                                                    class="loan-insurance-link">insurance
                                                                                </a>



                                                                            </label>
                                                                        </div>
                                                                        <div class="radio-wrapper">
                                                                            <input type="radio" name="personalInsurance"
                                                                                id="personal-insurance-no" />
                                                                            <label for="personal-insurance-no"
                                                                                class="nbd-personal-loan">I
                                                                                have
                                                                                my own
                                                                                insurance</label>
                                                                        </div>

                                                                    </div> -->

                                                                </div>
                                                                <div class="col-md-6 col-sm-12 right-panel">
                                                                    <div class="result-panel">
                                                                        <div>
                                                                            <h6 class="nbd-title h7">
                                                                                How much
                                                                                you’ll pay back each
                                                                                month
                                                                                <a href="javaScript:void(0)"
                                                                                    data-toggle="tooltip"
                                                                                    data-placement="top"
                                                                                    aria-labelledby=""
                                                                                    title="An estimate of your monthly loan instalment, including interest, fees and monthly insurance premium (if you took out cover with Nedbank).">
                                                                                    <img src="assets/images/icons/tooltipon.svg"
                                                                                        class="tooltip-img"
                                                                                        alt="tooltip text" />
                                                                                </a>
                                                                            </h6>
                                                                            <h2 class="green-text nbd-card-amount"
                                                                                id="monthlyInstallmentcal">
                                                                                R0.00
                                                                            </h2>
                                                                        </div>

                                                                        <div>
                                                                            <h6 class="nbd-title h7">
                                                                                How much
                                                                                you’ll pay back in
                                                                                total
                                                                                <a href="javaScript:void(0)"
                                                                                    data-toggle="tooltip"
                                                                                    data-placement="top"
                                                                                    aria-labelledby=""
                                                                                    title="An estimate of your total monthly instalments, total interest over the term, all fees and insurance premiums (if you took out cover with Nedbank).">
                                                                                    <img src="assets/images/icons/tooltipon.svg"
                                                                                        class="tooltip-img"
                                                                                        alt="tooltip text" />
                                                                                </a>
                                                                            </h6>

                                                                            <h2 class="nbd-card-amount"
                                                                                id="totalRepaymentcal">
                                                                                R0.00
                                                                            </h2>
                                                                        </div>

                                                                        <div>
                                                                            <h6 class="nbd-title h7">
                                                                                Example
                                                                                interest rate
                                                                                <a href="javaScript:void(0)"
                                                                                    data-toggle="tooltip"
                                                                                    data-placement="top"
                                                                                    aria-labelledby=""
                                                                                    title="Once you have submitted your application, we will assess the total costs of the loan and send you a preagreement quote.">
                                                                                    <img src="assets/images/icons/tooltipon.svg"
                                                                                        class="tooltip-img"
                                                                                        alt="tooltip text" />
                                                                                </a>
                                                                            </h6>
                                                                            <div class="row">
                                                                                <h2 class="col-6 interest-result"
                                                                                    id="repay_interest-value">
                                                                                </h2>
                                                                                <div class="col-6 change-rate-wrapper">
                                                                                    <button type="button"
                                                                                        class="change-rate collapsed"
                                                                                        data-toggle="collapse"
                                                                                        data-target="#interest-rate"
                                                                                        data-keyboard="false"
                                                                                        data-backdrop="static">Explore
                                                                                        rate
                                                                                        <span class="down-arrow"></span>
                                                                                    </button>

                                                                                </div>
                                                                            </div>
                                                                            <div id="interest-rate"
                                                                                class="collapse interest-rate">
                                                                                <div class="slidecontainer">
                                                                                    <output class="bubble"></output>
                                                                                    <input type="range" min="11"
                                                                                        max="28.75" value="18"
                                                                                        step="0.25" class="slider"
                                                                                        id="interest-rate-slider" />
                                                                                    <p class="range-info">
                                                                                        11.25%
                                                                                    </p>
                                                                                    <p class="range-info float-right">
                                                                                        28.75%</p>
                                                                                </div>
                                                                                <div class="interest-rate-desc">
                                                                                    <div class="cmp-text">
                                                                                        <p>On
                                                                                            average,
                                                                                            South
                                                                                            Africans
                                                                                            will pay
                                                                                            interest
                                                                                            of
                                                                                            18.75%
                                                                                            to
                                                                                            29.25%.
                                                                                            We’ll
                                                                                            offer
                                                                                            you an
                                                                                            interest
                                                                                            rate
                                                                                            based
                                                                                            on your
                                                                                            payment
                                                                                            history
                                                                                            and risk
                                                                                            profile.
                                                                                        </p>

                                                                                    </div>
                                                                                </div>

                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    <div class="row button-wrapper">
                                                                        <div
                                                                            class="panel-button col-lg-6 col-md-12 col-sm-12">
                                                                            <!-- Left side Button -->

                                                                            <a href="" data-keyboard="true"
                                                                                data-toggle="modal"
                                                                                data-target="#breakdown"
                                                                                id="repay_loan-breakdown"
                                                                                class="btn nbd-btn nbd-btn-tertiary nbd-anchor-btn">See
                                                                                loan details
                                                                                <i
                                                                                    class="tertiary-btn-icon up-right-arrow-btn"></i>
                                                                            </a>


                                                                            <!-- left side buttons -->

                                                                        </div>



                                                                        <div
                                                                            class="panel-button col-lg-6 col-md-12 col-sm-12">

                                                                            <!-- Right side Button -->


                                                                            <a href="/apply"
                                                                                class="btn nbd-btn nbd-anchor-btn nbd-btn-commitment"
                                                                                id="repay_startApplication"
                                                                                data-pagequicklinktype="link"
                                                                                data-pagequicklinkname="Apply now">Apply
                                                                                now</a>






                                                                            <!-- right side buttons -->

                                                                        </div>

                                                                    </div>




                                                                    <!-- Modal -->
                                                                    <div id="breakdown" class="modal " role="dialog"
                                                                        tabindex='-1'>
                                                                        <div class="modal-dialog modal-lg">

                                                                            <!-- Modal content-->
                                                                            <div
                                                                                class="modal-content shadow-lg p-3 mb-5 bg-white rounded">
                                                                                <div class="modal-body">
                                                                                    <div class="card-body">
                                                                                        <button type="button"
                                                                                            class="close"
                                                                                            data-dismiss="modal">
                                                                                            <img src="assets/images/icons/close-overlay.svg"
                                                                                                alt="close popup" />
                                                                                        </button>
                                                                                        <div class="row">
                                                                                            <div
                                                                                                class="col-md-6 col-sm-12 breakdown-header">
                                                                                                <h6
                                                                                                    class="nbd-description h7">
                                                                                                    Item
                                                                                                </h6>
                                                                                            </div>
                                                                                            <div
                                                                                                class="col-md-6 hide-text">
                                                                                                <h6
                                                                                                    class="nbd-description h7">
                                                                                                    Description
                                                                                                </h6>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="nbd-details-row">
                                                                                            <div
                                                                                                class="nbd-details-col-1 my-auto">
                                                                                                <p>How
                                                                                                    much
                                                                                                    do
                                                                                                    you
                                                                                                    want
                                                                                                    to
                                                                                                    borrow?
                                                                                                </p>
                                                                                                <p id="amountborrowed"
                                                                                                    class="breakdown-val">
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                class="nbd-details-col-2 my-auto">
                                                                                                <p>The
                                                                                                    amount
                                                                                                    we
                                                                                                    pay
                                                                                                    into
                                                                                                    your
                                                                                                    account.
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="nbd-details-row">
                                                                                            <div
                                                                                                class="nbd-details-col-1 my-auto">
                                                                                                <p>How
                                                                                                    much
                                                                                                    you’ll
                                                                                                    pay
                                                                                                    back
                                                                                                    each
                                                                                                    month
                                                                                                </p>
                                                                                                <p id="monthlyinstallments"
                                                                                                    class="breakdown-val">
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                class="nbd-details-col-2 my-auto">
                                                                                                <p>The
                                                                                                    amount
                                                                                                    we
                                                                                                    debit
                                                                                                    from
                                                                                                    your
                                                                                                    account
                                                                                                    every
                                                                                                    month
                                                                                                    on
                                                                                                    your
                                                                                                    salary
                                                                                                    date.
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="nbd-details-row">
                                                                                            <div
                                                                                                class="nbd-details-col-1 my-auto">
                                                                                                <p>How
                                                                                                    much
                                                                                                    you’ll
                                                                                                    pay
                                                                                                    back
                                                                                                    in
                                                                                                    total
                                                                                                </p>
                                                                                                <p id="totalcost"
                                                                                                    class="breakdown-val">
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                class="nbd-details-col-2 my-auto">
                                                                                                <p> The
                                                                                                    total
                                                                                                    amount
                                                                                                    you
                                                                                                    would
                                                                                                    have
                                                                                                    paid
                                                                                                    at
                                                                                                    the
                                                                                                    end
                                                                                                    of
                                                                                                    the
                                                                                                    loan
                                                                                                    term,
                                                                                                    including
                                                                                                    the
                                                                                                    loan,
                                                                                                    interest,
                                                                                                    fees
                                                                                                    and,
                                                                                                    if
                                                                                                    you
                                                                                                    included
                                                                                                    the
                                                                                                    premium
                                                                                                    in
                                                                                                    your
                                                                                                    calculation,
                                                                                                    your
                                                                                                    insurance.
                                                                                                    <span
                                                                                                        id="totalcostterm"></span>
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="nbd-details-row">
                                                                                            <div
                                                                                                class="nbd-details-col-1 my-auto">
                                                                                                <p>How
                                                                                                    much
                                                                                                    you’ll
                                                                                                    pay
                                                                                                    in
                                                                                                    interest,
                                                                                                    fees
                                                                                                    and
                                                                                                    premiums
                                                                                                </p>
                                                                                                <p id="totalinterest"
                                                                                                    class="breakdown-val">
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                class="nbd-details-col-2 my-auto">
                                                                                                <p>The
                                                                                                    total
                                                                                                    amount
                                                                                                    you
                                                                                                    would
                                                                                                    have
                                                                                                    paid
                                                                                                    towards
                                                                                                    interest,
                                                                                                    fees
                                                                                                    and,
                                                                                                    if
                                                                                                    you
                                                                                                    included
                                                                                                    the
                                                                                                    premium
                                                                                                    in
                                                                                                    your
                                                                                                    calculation,
                                                                                                    your
                                                                                                    insurance.
                                                                                                    <span
                                                                                                        id="totalinterestterm"></span>
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="nbd-details-row">
                                                                                            <div
                                                                                                class="nbd-details-col-1 my-auto">
                                                                                                <p>Loan
                                                                                                    term
                                                                                                </p>
                                                                                                <p id="loanschedule"
                                                                                                    class="breakdown-val">
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                class="nbd-details-col-2 my-auto">
                                                                                                <p>The
                                                                                                    time
                                                                                                    you
                                                                                                    chose
                                                                                                    to
                                                                                                    pay
                                                                                                    back
                                                                                                    the
                                                                                                    loan.
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="nbd-details-row">
                                                                                            <div
                                                                                                class="nbd-details-col-1 my-auto">
                                                                                                <p>Initiation
                                                                                                    fee
                                                                                                </p>
                                                                                                <p id="initfee"
                                                                                                    class="breakdown-val">
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                class="nbd-details-col-2 my-auto">
                                                                                                <p>We
                                                                                                    charge
                                                                                                    a
                                                                                                    once-off
                                                                                                    fee
                                                                                                    to
                                                                                                    process
                                                                                                    the
                                                                                                    loan.
                                                                                                    This
                                                                                                    will
                                                                                                    be
                                                                                                    added
                                                                                                    to
                                                                                                    the
                                                                                                    total
                                                                                                    amount
                                                                                                    you
                                                                                                    borrow.
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="nbd-details-row">
                                                                                            <div
                                                                                                class="nbd-details-col-1 my-auto ">
                                                                                                <p>Monthly
                                                                                                    service
                                                                                                    fee
                                                                                                </p>
                                                                                                <p id="monthlyadminfee"
                                                                                                    class="breakdown-val">
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                class="nbd-details-col-2 my-auto">
                                                                                                <p>We
                                                                                                    charge
                                                                                                    a
                                                                                                    monthly
                                                                                                    fee
                                                                                                    to
                                                                                                    service
                                                                                                    your
                                                                                                    personal
                                                                                                    loan
                                                                                                    account
                                                                                                    over
                                                                                                    the
                                                                                                    loan
                                                                                                    term.
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="nbd-details-row">
                                                                                            <div
                                                                                                class="nbd-details-col-1 my-auto ">
                                                                                                <p>Early
                                                                                                    settlement
                                                                                                    fee
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                class="nbd-details-col-2 my-auto">
                                                                                                <p>If
                                                                                                    you
                                                                                                    pay
                                                                                                    back
                                                                                                    your
                                                                                                    loan
                                                                                                    before
                                                                                                    the
                                                                                                    end
                                                                                                    of
                                                                                                    your
                                                                                                    loan
                                                                                                    term,
                                                                                                    we
                                                                                                    won&#39;t
                                                                                                    charge
                                                                                                    any
                                                                                                    fees.
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="nbd-details-row">
                                                                                            <div
                                                                                                class="nbd-details-col-1 my-auto">
                                                                                                <p>Late
                                                                                                    penalty
                                                                                                    fee
                                                                                                </p>
                                                                                            </div>
                                                                                            <div
                                                                                                class="nbd-details-col-2 my-auto">
                                                                                                <p>If
                                                                                                    you
                                                                                                    make
                                                                                                    a
                                                                                                    payment
                                                                                                    after
                                                                                                    missing
                                                                                                    your
                                                                                                    monthly
                                                                                                    repayment
                                                                                                    date,
                                                                                                    we
                                                                                                    don&#39;t
                                                                                                    charge
                                                                                                    you
                                                                                                    a
                                                                                                    late
                                                                                                    penalty
                                                                                                    fee.
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                                <div class="modal-footer">
                                                                                    <div class="row popup-buttons">
                                                                                        <div
                                                                                            class="col-lg-4 col-md-12 col-sm-12 popup-footer-note my-auto ">
                                                                                            All fees
                                                                                            and
                                                                                            costs
                                                                                            include
                                                                                            VAT.
                                                                                        </div>
                                                                                        <div
                                                                                            class="col-lg-4 col-md-6 col-sm-12">
                                                                                            <!-- Left side Button -->




                                                                                            <a href="/"
                                                                                                data-dismiss="modal"
                                                                                                class="btn nbd-btn nbd-btn-secondary nbd-anchor-btn"
                                                                                                id="repaypopupmdleftbtn">Close
                                                                                                loan
                                                                                                details</a>







                                                                                            <!-- left side buttons -->
                                                                                        </div>


                                                                                        <div
                                                                                            class="col-lg-4 col-md-6 col-sm-12">

                                                                                            <!-- Right side Button -->


                                                                                            <a href="/apply"
                                                                                                class="btn nbd-btn nbd-anchor-btn nbd-btn-primary"
                                                                                                id="repaypopupmdrightbtn">Apply
                                                                                                now</a>






                                                                                            <!-- right side buttons -->

                                                                                        </div>


                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text aem-GridColumn aem-GridColumn--default--12">


                                                <div class=" ng-container cmp-text customtext">
                                                    <p> </p>
                                                    <p><span class="nbd-disclaimer">Our calculation
                                                            is only an
                                                            example of how the interest rate and
                                                            fees can affect
                                                            your repayments. Although we do our best
                                                            to give you
                                                            accurate calculations, they will not be
                                                            binding on
                                                            us. </span>
                                                    </p>

                                                </div>
                                                <!-- <sly data-sly-call=""/> -->



                                            </div>


                                        </div>

                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="readytoapply aem-GridColumn aem-GridColumn--default--12">
                <div class="container-fluid p-0 ctacomponent">
                    <div class="nbd-rta-comp rta-bg-charcoal ">
                        <div class="ng-container">
                            <div class="col-12">
                                <h3 class="nbd-rta-title">Ready <span>to apply?</span></h3>
                                <a href="/apply" target="_self" class="btn nbd-btn nbd-btn-secondary" id="rtaCTA"
                                    data-pagequicklinktype="link" data-pagequicklinkname="Get started"
                                    data-pagequicklinklocation="Ready to apply? | main content">
                                    Get started
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 mb-5">

                <div class="spacing aem-GridColumn aem-GridColumn--default--12">


                    <div style="height:80px;" class="clearfix "></div>
                </div>
                <div class="headingwithdesc aem-GridColumn aem-GridColumn--default--12">



                    <div class="whitebg">
                        <div class="nbd-head-desc-wrapper">
                            <h2 class="nbd-league-pagetitle">Service <span>with a smile</span></h2>
                            <div class="nbd-head-desc">
                                <p>Nedbank Support Centre
                                    <br>
                                    Contact number: 0800 555 111
                                    <br>
                                    If you have any questions about your registration with your educational
                                    institution, you can contact SmartFunder on <a
                                        href="mailto: nedbankeducation@smartfunder.co.za">
                                        nedbankeducation&#64;smartfunder.co.za</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>